import {
   GET_CATEGORIES,
   GET_NEXT_CATEGORIES,
   UPDATE_CATEGORY_STATUS,
   ADD_NEW_CATEGORY,
   GET_ACTIVE_CATEGORIES,
   UPDATE_CATEGORY_NAME
 }  from './../actions/types';
 
 const INITIAL_STATE = {
    analysisCategories: [],
    activeCategories: [],
 };
 
 export default function (state = INITIAL_STATE , action)
 {
     switch(action.type){
         case GET_CATEGORIES : 
         return {
             ...state,
             analysisCategories: action.payload,
         }

         case UPDATE_CATEGORY_STATUS: {
             const {index, currentStatus} = action;
         return {
             ...state,
             analysisCategories: [...state.analysisCategories.slice(0, index), {...state.analysisCategories[index], status: !currentStatus}, ...state.analysisCategories.slice(index + 1)]
         }
        }

        case UPDATE_CATEGORY_NAME: {
             const {index, updateName} = action;
         return {
             ...state,
             analysisCategories: [...state.analysisCategories.slice(0, index), {...state.analysisCategories[index], name: updateName}, ...state.analysisCategories.slice(index + 1)]
         }
        }
        

        case ADD_NEW_CATEGORY: 
        return {
            ...state,
            analysisCategories: [...state.analysisCategories, action.payload]
        }

        case GET_ACTIVE_CATEGORIES:
        return {
            ...state,
            activeCategories: action.payload
        }
        case GET_NEXT_CATEGORIES:
        return {
            ...state,
            analysisCategories: action.payload
        }
     
      
         default :
         return {
             ...state
         };
     }
 }